import { SpravaoUcastiVerejnostiApi } from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import {
  SpravaOUcastiVerejnostiFormData,
} from '../../../model/sprievodnyDokument/spravaoUcastiVerejnosti/SpravaOUcastiVerejnostiFormData';
import Uuid from '../../../model/Uuid';
import map from './spravaoUcastiVerejnostiMapper';

const client = new SpravaoUcastiVerejnostiApi(apiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const createSpravaoUcastiVerejnostiClient = async (
  uuid: Uuid,
  spravaoUcastiVerejnosti: SpravaOUcastiVerejnostiFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createSpravaOUcastiVerejnosti(uuid, map(spravaoUcastiVerejnosti), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const updateSpravaoUcastiVerejnostiClient = async (
  uuid: Uuid,
  spravaoUcastiVerejnosti: SpravaOUcastiVerejnostiFormData,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.editSpravaoUcastiVerejnosti(uuid, map(spravaoUcastiVerejnosti), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};
